import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-cinema-bg">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">{contactInfo.title}</h2>
        <p className="text-sm text-cinema-gold mb-2">{contactInfo.subtitle}</p>
        <p className="text-sm text-cinema-text-dim leading-relaxed mb-10 max-w-xl mx-auto">{contactInfo.desc}</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {contactInfo.methods.map((method, i) => (
            <a
              key={i}
              href={i === 2 ? '#faq' : '#'}
              className="group flex flex-col items-center gap-3 bg-cinema-card hover:bg-cinema-card-hover border border-cinema-border hover:border-cinema-gold/20 rounded-xl p-6 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold group-hover:bg-cinema-gold/20 transition-colors">
                <i className={`${method.icon} text-xl`}></i>
              </div>
              <div>
                <div className="text-xs text-cinema-muted mb-1">{method.label}</div>
                <div className="text-sm font-semibold text-white group-hover:text-cinema-gold transition-colors">{method.value}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}